import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { isAndroidApp } from '@/utils/platformUtils';
import { useCapacitorUpdateStore } from '@/stores/capacitor/capacitorUpdateStore';

let listenersRegistered = false;

export async function applyCapacitorUpdate(): Promise<void> {
  const { pendingBundleId } = useCapacitorUpdateStore.getState();
  if (!pendingBundleId) return;

  await CapacitorUpdater.set({ id: pendingBundleId });
  useCapacitorUpdateStore.getState().clear();
}

export async function initCapacitorUpdater(): Promise<void> {
  if (!isAndroidApp()) return;

  try {
    if (!listenersRegistered) {
      await CapacitorUpdater.addListener('downloadComplete', (event) => {
        useCapacitorUpdateStore
          .getState()
          .showUpdate(event.bundle.id, event.bundle.version);
      });

      await CapacitorUpdater.addListener('downloadFailed', (event) => {
        console.error('[CapacitorUpdater] download failed:', event.version);
      });

      await CapacitorUpdater.addListener('updateFailed', (event) => {
        console.error(
          '[CapacitorUpdater] update failed:',
          event.bundle.version,
        );
      });
      await CapacitorUpdater.addListener('updateAvailable', (event) => {
        useCapacitorUpdateStore
          .getState()
          .showUpdate(event.bundle.id, event.bundle.version);
      });

      listenersRegistered = true;
    }

    await CapacitorUpdater.notifyAppReady();
    await promptIfPendingBundleDownloaded();
  } catch (error) {
    console.error('[CapacitorUpdater] init failed', error);
  }
}

async function promptIfPendingBundleDownloaded() {
  const { bundle: current } = await CapacitorUpdater.current();
  const { bundles } = await CapacitorUpdater.list();
  const pending = bundles.find(
    (b) => b.status === 'pending' && isVersionNewer(b.version, current.version)
  );
  if (pending) {
    useCapacitorUpdateStore.getState().showUpdate(pending.id, pending.version);
  }
}

export function isVersionNewer(version1: string, version2: string): boolean {
  const splittedVersion1 = version1.split('.').map(Number);
  const splittedVersion2 = version2.split('.').map(Number);

  for (let i = 0; i < splittedVersion1.length; i++) {
    if (splittedVersion1[i] > splittedVersion2[i]) return true;
    if (splittedVersion1[i] < splittedVersion2[i]) return false;
  }

  return false;
}